import { render, staticRenderFns } from "./version_edit.vue?vue&type=template&id=20a208a8&scoped=true"
import script from "./version_edit.vue?vue&type=script&lang=js"
export * from "./version_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a208a8",
  null
  
)

export default component.exports